export function showPlannerView() {
  const user = useState('user');

  if (user.value && user.value.subscription === 'planner') {
    const usePlannerView = useCookie('usePlannerView');
    if (usePlannerView.value) {
      return true;
    }
    else {
      return false;
    }
  }
  else {
    return false;
  }
}